import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/landing">Tourism</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/generic">Animal kingdom</Link></li>
                <li><Link onClick={props.onToggleMenu} to="https://naturehub.netlify.app/">Nature Wallpapers </Link></li>
            </ul>
            <ul className="actions vertical">
                <li><a href="https://paatubeo.blogspot.com/search/label/Nature" className="button special fit">Nature Videos</a></li>
                <li><a href="https://paajoelibrary.blogspot.com/search/label/Nature?&max-results=8" className="button fit">Documentaries of Nature</a></li>
                 <li><a href="https://paatubeo.blogspot.com/search/label/AroundTheWorld" className="button fit">Travel  </a></li>
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu
